var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-white px-2 py-1 rounded text-xs tracking-wider",class:_vm.isTypeImage ? 'bg-red-400' : 'bg-gray-700'},[(_vm.getIconByType)?_c('fa-icon',{staticClass:"mr-2",attrs:{"icon":_vm.getIconByType,"fixed-width":""}}):_vm._e(),_vm._v(" "+_vm._s(_vm.getLabelByType)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }